const features = [
  {
    title: 'Instagram, WhatsApp ve Facebook Karşılama Akışı',
    description:
      'Mesaj atan, yorum yapan veya etkileşime giren kişilere doğal görünen, işinize özel hazırlanmış cevap sistemleri.',
    icon: 'ri-message-3-line',
  },
  {
    title: 'Yapay Zeka Destekli Davranış Analizi',
    description:
      'Gelen kişinin ilgisini, cevaplarını, hangi aşamada kaldığını ve satışa yakınlığını anlamaya yönelik analiz yapısı.',
    icon: 'ri-brain-line',
  },
  {
    title: 'Müşteri Takip Paneli',
    description:
      'Kim olumlu, kim olumsuz, kim randevu aldı, kim satışa döndü, kim tekrar aranmalı gibi tüm başvuruları takip edebileceğiniz özel panel.',
    icon: 'ri-dashboard-3-line',
  },
  {
    title: 'Reklam Görselleri ve Metinleri',
    description:
      'İşinize özel reklam metinleri, kampanya içerikleri, görsel fikirleri ve gerekirse video içerik yapıları.',
    icon: 'ri-image-edit-line',
  },
  {
    title: 'Yorum ve Mesaj Dönüş Sistemi',
    description:
      'Reklama yorum atan, mesaj gönderen veya bilgi isteyen kişilerin hızlı şekilde karşılanması.',
    icon: 'ri-chat-check-line',
  },
  {
    title: 'Randevu ve Satış Takibi',
    description:
      'Randevu oluşturma, hatırlatma, gelmeyen kişiyi tekrar yönlendirme, satışa yakın kişileri takip etme yapısı.',
    icon: 'ri-calendar-todo-line',
  },
  {
    title: 'Davranış Analizi Odaklı Landing Page',
    description:
      'Gerekirse kişinin hangi içeriklerle ilgilendiğini anlamaya çalışan özel web sayfası.',
    icon: 'ri-pages-line',
  },
  {
    title: 'İşe Özel Ek Panel veya Yazılım',
    description:
      'Servis takibi, ödeme takibi, kayıt takibi, personel takibi, kampanya mesajları veya iş akış yönetimi gibi özel ihtiyaçlar.',
    icon: 'ri-tools-line',
  },
];

export default function WhatIncludedSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100" id="neler-dahil">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            İlk Ay Kurulumunda Neler Dahil?
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {features.map((item) => (
            <div
              key={item.title}
              className="group p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/50 hover:border-accent-200/50 transition-all duration-300 cursor-default"
            >
              <div className="w-11 h-11 rounded-xl bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-200 transition-colors duration-300">
                <i className={`${item.icon} text-accent-600 text-lg`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 text-sm mb-2 leading-snug">
                {item.title}
              </h3>
              <p className="text-foreground-600 text-xs leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a
            href="https://wa.me/905069992900?text=Merhaba%2C%20sisteminizi%20inceledim.%20Benim%20i%C3%A7in%20uygundur.%20%C3%9Ccretsiz%20%C3%B6rnek%20sistem%20haz%C4%B1rl%C4%B1%C4%9F%C4%B1%20i%C3%A7in%20bilgi%20vermek%20istiyorum."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-500 text-background-50 font-semibold text-sm hover:bg-accent-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line"></i>
            Uygundur Yaz ve Başla
          </a>
        </div>
      </div>
    </section>
  );
}